import React from "react";
import { Popcorn } from "phosphor-react";

const Card = ({ data }) => {
  return (
    <>
      <div className="p-4 bg-white rounded-xl border">
        <div className="flex items-center justify-between">
          <div className="flex space-x-4 items-center">
            <div className="flex animate-pulse items-center justify-center h-14 w-14 rounded-full bg-slate-100">
              <Popcorn size={24} />
            </div>
            <div className="animate-pulse bg-slate-100 rounded-lg h-6 w-28"></div>
          </div>
          <div className="animate-pulse h-9 w-20 bg-slate-100 rounded-lg px-4 py-1 text-sm lg:text-base lg:w-20 lg:h-9"></div>
        </div>
      </div>
    </>
  );
};

export default Card;
